export default __webpack_public_path__ + "static/media/lp-sec07_ttl.9cda20d9.png";